import { IconComponent } from "@vygruppen/spor-icon-react";
import type { ColorScheme } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/types";
import { InternalMessageResponse } from "features/CenterContent/RoleContent/InternalMessage/schema/responseSchema";
import { FC, useMemo } from "react";
import { Semantics } from "shared/components/drops/DropsBadge";
import { semanticsToVariant } from "shared/utils/semantics";
import { Box, DropsStaticAlert, Text } from "shared/components/Spor";
import { NoteFill18Icon } from "shared/icons/NoteIcon";

const createNoteIconWithBox = (fill: string): IconComponent =>
  ((props) => (
    <Box mt="-2px">
      <NoteFill18Icon {...props} {...({ $fill: fill } as object)} />
    </Box>
  )) as IconComponent;

type InternalMessage = Pick<
  InternalMessageResponse,
  "uuid" | "updatedAt" | "customTexts"
>;

type InternalMessageBoxProps = {
  messages: InternalMessage[];
  colorScheme: ColorScheme;
  semantics: Semantics;
};

export const InternalMessageBox: FC<InternalMessageBoxProps> = ({
  messages,
  colorScheme,
  semantics,
}) => {
  const icon = useMemo(
    () => createNoteIconWithBox(colorScheme.accentColor),
    [colorScheme.accentColor],
  );

  if (!messages || messages.length === 0) {
    return null;
  }

  return (
    <DropsStaticAlert
      variant={semanticsToVariant(semantics)}
      title="Internmelding"
      icon={icon}
      width="100%"
    >
      <Text fontWeight="normal">
        {messages[0]?.customTexts[0]?.texts.NOB?.description ??
          "Ingen beskrivelse tilgjengelig"}
      </Text>
    </DropsStaticAlert>
  );
};
